import React, { Component } from 'react';
import {
  SortableContainer,
  SortableElement,
  arrayMove
} from 'react-sortable-hoc';
import { TextField, Button } from '@material-ui/core';
import { observer, Observer, inject } from 'mobx-react';
import styles from './MultiImageUpload.css';
import { callbackify } from 'util';
import SvgIcon from '@material-ui/core/SvgIcon';

import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

var ObjectID = require('bson-objectid');
var pictureTitles = [];

@inject('formDataStore')
@observer
export default class SortableComponent extends Component {
  constructor(props) {
    super(props);
    
    this.getImages().map((image, index) => {
      pictureTitles[index] = image.title;
    });
    
    this.getImages = this.getImages.bind(this);
  }

  state = {
    selectedFile: null,
    refreshTicker: 1
  };

  getImages() {
    return this.props.formDataStore.findObjectReference('customerCase', this.props.path) || [];
  }

  ImageUploadHandler = (targetObject, event) => {
    this.props.formDataStore.uploadImages(event.target.files, callback => {
      callback.map(imageObject => {
        this.props.formDataStore.addObjectToArray(targetObject, this.props.path, {
          _id: imageObject.filename,
          title: 'Kuvausteksti',
          type: 'placeholder',
          ordering: 10
        });
      });
      this.forceUpdate();
    });
  };

  assignValueToPropertyHandler(targetObject, id, key, event) {
    this.props.formDataStore.assignValueToProperty(
      targetObject,
      id,
      this.props.path,
      key,
      event.target.value
    );
  }

  ImageRemovalHandler = (targetObject, id) => {
    this.props.formDataStore.removeImage(id, callback => {
      this.props.formDataStore.removeObject(targetObject, this.props.path, id);
      this.forceUpdate();
    });
  };

  __onSortEnd = ({ oldIndex, newIndex }) => {
    this.props.formDataStore.assignValueToPath(
      'customerCase', 
      this.props.path, 
      arrayMove(
        this.getImages(),
        oldIndex,
        newIndex
      )
    );
  };

  render() {
    var items = {
      caseImages: this.getImages(),
      handleChangeFunction: this.props.formDataStore.assignValueToProperty
    };
    const SortableItem = SortableElement(({ value }) => (
      <div style={styles.imageBox}>{value}</div>
    ));

    const containerHeight =
      Math.ceil(items.caseImages.length / 4) *
      204;

    const SortableList = SortableContainer(() => (
      <Observer>
        {() => (
          <div style={{ ...styles.imageBoxContainer, height: containerHeight }}>
            {items.caseImages.map(
              (imageFile, index) => (
                <SortableItem
                  key={`item-${index}`}
                  index={index}
                  value={
                    <div>
                      <img
                        src={`/api/v1/images/${imageFile._id}`}
                        alt="kuva"
                        style={styles.image}
                      />
                      <div>
                        <IconButton
                          onClick={() => {
                            this.ImageRemovalHandler(
                              'customerCase',
                              imageFile._id
                            );
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </div>
                      <TextField
                        value={
                          items.caseImages[
                            index
                          ].title
                        }
                        onChange={event => {
                          this.assignValueToPropertyHandler(
                            'customerCase',
                            imageFile._id,
                            'title',
                            event
                          );
                        }}
                      />
                    </div>
                  }
                />
              )
            )}
          </div>
        )}
      </Observer>
    ));

    return (
      <div>
        <input
          name="caseImage"
          type="file"
          multiple
          onChange={event => {
            this.ImageUploadHandler('customerCase', event);
          }}
        />
        <SortableList
          lockToContainerEdges={true}
          distance={2}
          axis={'xy'}
          transitionDuration={300}
          onSortEnd={this.__onSortEnd}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/CreateNewCase/MultiImageUpload/MultiImageUpload.jsx